import { NgModule } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import { OnboardingPage } from './onboarding/onboarding.page';
import { LoginPage } from './login/login.page';
import { SplashScreenPage } from './splash-screen/splash-screen.page';
import { ReactiveFormsModule } from '@angular/forms';
import { RegisterPage } from './register/register.page';
import { MatButtonModule } from '@angular/material/button';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { VerificationPage } from './verification/verification.page';
import { NotFoundPage } from './notfound/notfound.page';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { CreateNewPasswordPage } from './create-new-password/create-new-password.page';
import { HomePage } from './home/home.page';
import { BusinessSettingsPage } from './business-settings/business-settings.page';
import { InvitePage } from './invite/invite.page';
import { CreateAccountPage } from './create-account/create-account.page';
import { ProfileCreatedPage } from './profile-created/profile-created.page';
import { InviteExistingPage } from './invite-existing/invite-existing.page';
import { ConfirmedMembershipPage } from './confirmed-membership/confirmed-membership.page';
import { ProductCouponPage } from './product-coupon/product-coupon.page';
import { InviteRefusePage } from './invite-refuse/invite-refuse.page';
import { RewardPage } from './reward/reward.page';
import { AddPointsPage } from './add-points/add-points.page';
import { PointBalancePage } from './point-balance/point-balance.page';
import { RewardsListPage } from './rewards-list/rewards-list.page';
import { CouponsPage } from './coupons/coupons.page';
import { AccountSettingsPage } from './account-settings/account-settings.page';
import { ChangePasswordPage } from './change-password/change-password.page';
import { DeleteAccountPage } from './delete-account/delete-account.page';
import { AccountDeletedPage } from './account-deleted/account-deleted.page';
import { TranslocoModule } from '@ngneat/transloco';
import { ExpiredInvitePage } from './expired-invite/expired-invite.page';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { FaqPage } from './faq/faq.page';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PointBalanceListPage } from './point-balance-list/point-balance-list.page';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    TranslocoModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatChipsModule,
    CarouselModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule,
    InfiniteScrollModule,
    MatDatepickerModule,
    NgIf,
  ],
  declarations: [
    OnboardingPage,
    SplashScreenPage,
    LoginPage,
    RegisterPage,
    VerificationPage,
    NotFoundPage,
    ForgotPasswordPage,
    CreateNewPasswordPage,
    HomePage,
    BusinessSettingsPage,
    InvitePage,
    CreateAccountPage,
    ProfileCreatedPage,
    InviteExistingPage,
    ConfirmedMembershipPage,
    ProductCouponPage,
    InviteRefusePage,
    RewardPage,
    AddPointsPage,
    PointBalancePage,
    PointBalanceListPage,
    RewardsListPage,
    CouponsPage,
    AccountSettingsPage,
    ChangePasswordPage,
    DeleteAccountPage,
    AccountDeletedPage,
    ExpiredInvitePage,
    FaqPage,
  ],
})
/**
 * Module for pages
 */
export class PagesModule {}
